import { render, staticRenderFns } from "./OrganisationDashboardInformation.vue?vue&type=template&id=d8be1992&"
import script from "./OrganisationDashboardInformation.vue?vue&type=script&lang=ts&"
export * from "./OrganisationDashboardInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8be1992')) {
      api.createRecord('d8be1992', component.options)
    } else {
      api.reload('d8be1992', component.options)
    }
    module.hot.accept("./OrganisationDashboardInformation.vue?vue&type=template&id=d8be1992&", function () {
      api.rerender('d8be1992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/organisationDashboard/OrganisationDashboardInformation.vue"
export default component.exports